import { MeasurementUnit } from "app/models/measurement-unit/measurement-unit";
import { Product } from "app/pages/products/product";

export class SimpleProduct {

  id: number;
  classificationId: number;
  name: string;
  classificationName: string;
  link: string;
  listPrice: number;
  measurementUnitInitials: string;
  offerPrice: number;
  price: number;
  quantity: number;
  selectedQuantity: number;
  hasBatch: boolean;
  classificationCount: number;
  measurementUnitCount: number;
  uniqueMeasurementUnit: MeasurementUnit;
  selectedMeasurementUnit: string;
  liquidValue: number;
  measurementUnits: MeasurementUnit[];
  measurementUnitQuantity: number;
  measurementUnitDescription: number;
  measurementUnitIndex: number;
  selectedMeasurementQuantity: number;
  selectedMeasurementIndex: number;

  static fromJson(json: any): SimpleProduct {
    var temp = new SimpleProduct();
    temp.id = json.ID;
    temp.name = json.NAME;
    temp.quantity = json.QUANTITY;
    temp.classificationId = json.IDCLAS;
    temp.classificationName = json.CLASSNAME;
    temp.link = json.LINK;
    temp.listPrice = json.LISTPRICE;
    temp.measurementUnitInitials = json.PRODUCTMEASUREUNIT;
    temp.offerPrice = json.OFFERPRICE;
    temp.price = json.PRICE;
    temp.hasBatch = (json.BATCH === 'S');
    temp.measurementUnitCount = json.MEASUREMENTUNITCOUNT;
    if (temp.measurementUnitCount == 1) {
      temp.uniqueMeasurementUnit = new MeasurementUnit();
      temp.uniqueMeasurementUnit.measurementInitials = json.PRODUCTMEASUREUNIT;
    }

    temp.selectedQuantity = (json.SELECTEDQUANTITY ?? 0);
    temp.selectedMeasurementUnit = json.SELECTEDUNDMED;
    temp.selectedMeasurementQuantity = json.SELECTEDUNDMEDQUANTITY;
    temp.liquidValue = json.LIQUIDVALUE;
    temp.measurementUnitQuantity = json.PRODUCTUNITMEASUREQUANTITY;
    temp.measurementUnitIndex = json.PRODUCTUNITMEASUREINDEX;
    temp.measurementUnitDescription = json.PRODUCTUNITMEASUREDESCRIPTION;
    temp.selectedMeasurementIndex = json.SELECTEDUNDMEDINDEX
    return temp;
  }

  static fromProduct(product: Product): SimpleProduct {
    var temp = new SimpleProduct();
    temp.id = product.productId;
    temp.name = product.name;
    temp.classificationId = product.classificationId;
    temp.classificationName = product.clasName;
    //temp.link = product.links[0] ?? "";
    temp.listPrice = product.listPrice;
    temp.measurementUnitInitials = product.defaultMeasurementUnit;
    temp.offerPrice = product.offerPrice;
    temp.price = product.price;
    return temp;
  }

  static fromJsonSimpleProduct(product: any): SimpleProduct {
    var temp = new SimpleProduct();
    temp.hasBatch = product.batch == 'S';
    temp.classificationName = product.clasName;
    temp.id = product.id;
    temp.classificationId = product.idClas;
    temp.link = product.link;
    temp.listPrice = product.listPrice;
    temp.measurementUnits = product.measurementUnit;
    temp.name = product.name;
    temp.offerPrice = product.offerPrice;
    temp.price = product.price;
    temp.measurementUnitInitials = product.productMeasureUnit;
    temp.quantity = product.quantity;
    temp.selectedMeasurementQuantity = product.selectedQuantity;
    temp.selectedMeasurementUnit = product.selectedUndMed;
    temp.selectedMeasurementQuantity = product.selectedUndMedQuantity;
    temp.price = product.price;
    return temp;
  }
}
